import React from "react";
import { Outlet } from "react-router-dom";
import { TopSalesBar } from "./TopSalesBar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { WhatsAppFab } from "./WhatsAppFab";

export const Layout = () => (
  <div className="min-h-screen flex flex-col bg-white">
    <TopSalesBar />
    <Header />
    <main className="flex-1">
      <Outlet />
    </main>
    <Footer />
    <WhatsAppFab />
  </div>
);
